class sticky {
    constructor(opts) {
        this.opts = $.extend({
            el: '#element',
            offsetTop: 56,
            openClose: [
                'p-nav--open', // p-nav--close
                'p-nav__btn--open', // p-nav__btn--close
            ],
        }, opts)

        this.$el = document.querySelector(this.opts.el)
        this.$btn = document.querySelector('.p-nav__btn')

        this._init()
    }

    _init() {
        this._settings()
        this._controls()
    }

    _settings() {
        this.$el.classList.add(`${this.opts.openClose[0]}`)
        this.$btn.classList.add(`${this.opts.openClose[1]}`)
        this.sticky()
    }

    _controls() {
        window.addEventListener('scroll', this.sticky.bind(this))

        this.$btn.addEventListener('click', this.statusCheck.bind(this))
    }

    sticky() {
        let scTop =
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop
        this.opts.offsetTop <= scTop
            ? this.$el.classList.add('p-nav--fix')
            : this.$el.classList.remove('p-nav--fix')
    }

    statusCheck() {
        if (this.$el.classList.contains('p-nav--open')) {
            this.closeClass()
        } else {
            this.openClass()
        }
    }

    openClass() {
        this.$btn.classList.remove('p-nav__btn--close')
        this.$btn.classList.add('p-nav__btn--open')
        this.$el.classList.remove('p-nav--close')
        this.$el.classList.add('p-nav--open')
    }

    closeClass() {
        this.$btn.classList.remove('p-nav__btn--open')
        this.$btn.classList.add('p-nav__btn--close')
        this.$el.classList.remove('p-nav--open')
        this.$el.classList.add('p-nav--close')
    }
}

export default sticky



// WEBPACK FOOTER //
// ./src/js/sticky.js